var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_content",style:({ 'padding-top': _vm.isApp ? '0' : '44px' })},[(!_vm.isApp)?_c('Headers'):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"router"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7a81f1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/operationViews/Layout/index.vue
// module id = null
// module chunks = 